module.exports = __webpack_public_path__ + "static/media/event_slide_1.a79a184e.png";